export default {
  title: 'Skonfiguruj nowe obciążenie',
  submitLabel: 'Załadowano {recipeCode}',
};
